import { observer } from 'src/utils/mobx-react';
import { EventSettings } from 'src/domains/sportsbook/trading/view/eventDetails/eventSettings/EventSettings';
import { EventMarkets } from 'src/domains/sportsbook/trading/view/eventDetails/markets/EventMarkets';
import { EventTags } from 'src/domains/sportsbook/trading/view/eventDetails/eventTags/EventTags';
import { EventResults } from 'src/domains/sportsbook/trading/view/eventDetails/eventResults/EventResults';
import { EventDebug } from 'src/domains/sportsbook/trading/view/eventDetails/eventDebug/EventDebug';
import React from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { DateTime } from 'src_common/utils/time/time';
import { EventShortSettings } from 'src/domains/sportsbook/trading/view/eventDetails/eventShortSettings/EventShortSettings';
import { EventTabItems } from 'src/domains/sportsbook/trading/view/eventDetails/EventTabItems';
import {
    EventDetailsHeader,
    EventDetailsHeaderWrapper,
    EventDetailsInfo,
    TabsContainerWrapper,
    TabsContentWrapper,
} from 'src/domains/sportsbook/trading/view/eventDetails/EventDetails.style';

interface EventDetailsPropsType {
    eventId: number;
    label: string;
}

export const EventDetails = observer('EventDetails', (props: EventDetailsPropsType) => {
    const { routerBackoffice, sdkStaff } = useAppStateContext();
    const event = sdkStaff.models.getEvent(props.eventId);
    if (event === null) {
        return <>Loading....</>;
    }

    const getTime = DateTime.from(event.timeSettingsStartTime)?.format('YYYY-MM-DD HH:mm:ss');

    const customerParams = routerBackoffice.getParametersString('events', 'tab') ?? 'event-settings';

    return (
        <>
            <EventDetailsHeaderWrapper className='event-details-header'>
                <EventDetailsHeader>
                    {event.name}
                    <EventDetailsInfo>
                        #{event.id} {getTime}
                    </EventDetailsInfo>
                </EventDetailsHeader>
                <EventShortSettings eventId={props.eventId} />
            </EventDetailsHeaderWrapper>

            <TabsContainerWrapper>
                <EventTabItems />

                <TabsContentWrapper>
                    {customerParams === 'event-settings' && <EventSettings eventId={event.id2} />}
                    {customerParams === 'markets' && <EventMarkets eventId={event.id2} />}
                    {customerParams === 'tags' && <EventTags eventId={event.id2} />}
                    {customerParams === 'results' && <EventResults eventId={event.id2} />}
                    {customerParams === 'debug' && <EventDebug eventId={event.id2} />}
                </TabsContentWrapper>
            </TabsContainerWrapper>
        </>
    );
});
